window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.searchResults = `
    <style>
        .product-tiles-block {
            position: relative;
            padding: 24px 0 29px;
        }

        .flex {
            display: flex;
            flex-wrap: wrap;
        }

        .product-group {
            width: calc(100% - 304px);
            flex: 1;
        }

        .product-filters {
            margin-right: 18px;
            width: 286px;
            padding-top: 31px;
        }

        .flex-center-end {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-end;
        }

        .filter-view-toggle {
            display: none;
            min-width: unset;
            padding: 12px 24px;
            max-width: 48.5%;
            flex: 1;
        }

        .btn {
            display: inline-block;
            font-family: Lato, sans-serif;
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 20px;
            letter-spacing: .02em;
            color: #fff;
            background-color: #e6007e;
            border: 1px solid #e6007e;
            padding: 8px 24px;
            text-decoration: none;
            transition: all .3s ease;
            cursor: pointer;
            border-radius: 0;
            min-width: 171px;
            text-align: center;
        }

        .flex-center-space-between {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-between;
        }

        @media screen and (max-width: 767px), print {
            .product-filters {
                position: fixed;
                width: 100%;
                height: 100vh;
                top: 0;
                left: -100%;
                z-index: 10999;
                background: #fff;
                padding: 24px;
                overflow: auto;
                transition: left .3s ease-in-out;
            }

            .product-filters.hawksearch-mobile-drawer-open {
                left: 0;
            }

            .filter-view-toggle {
                display: inline-block;
            }

            .btn {
                font-size: 14px;
                line-height: 20px;
                padding: 11px 24px;
            }

            .product-group .sort-wrap {
                top: 48px;
                z-index: 2;
                justify-content: space-between;
                padding: 14px 16px;
                margin-bottom: 10px;
                background: #fff;
                gap: 16px;
                width: calc(100% + 32px);
                margin-left: -16px;
            }

            .page-footer {
                flex-direction: column-reverse;
                margin-top: 8px;
            }
        }

        @media screen and (max-width: 767px), print {
            .product-tiles-block {
                padding: 8px 0 16px;
            }
        }

        @media screen and (max-width: 576px), print {
            .filter-view-toggle {
                max-width: 48%;
            }

            .btn {
                min-width: unset;
            }
        }

        /* HawkSearch checkbox facet: set --color-background here (or in style.css on the same selector). */
        :host, :root {
            --default-line-height: clamp(24px, 1.4vw, 29px);
            --default-font-color: #666;
            --default-font-color--inverse: '';
            --default-font-family: 'Open Sans', sans-serif;
            --default-font-size: clamp(14px, 1.4vw, 16px);;
            --padding-xs: '20';
            font-family: 'Open Sans', sans-serif;
            font-size: clamp(14px, 1.4vw, 16px);
            color: #666;
            line-height: clamp(24px, 1.4vw, 29px);
        }
    </style>
    <hawksearch-modified-query></hawksearch-modified-query>
    <hawksearch-query-suggestions></hawksearch-query-suggestions>
    <div class="product-tiles-block flex">
        <aside class="product-filters">
            <hawksearch-content-zone name="LeftTop"></hawksearch-content-zone>
            <hawksearch-facets-list></hawksearch-facets-list>
            <hawksearch-content-zone name="LeftBottom"></hawksearch-content-zone>
        </aside>
        <div class="product-group">
            <hawksearch-content-zone name="Top"></hawksearch-content-zone>
            <hawksearch-content-zone name="Top2"></hawksearch-content-zone>
            <hawksearch-tabs></hawksearch-tabs>
            <div class="sort-wrap flex-center-end">
                <hawksearch-sorting></hawksearch-sorting>
            </div>
            <hawksearch-search-results-list></hawksearch-search-results-list>
            <div class="page-footer flex-center-space-between">
                <hawksearch-page-size></hawksearch-page-size>
                <hawksearch-pagination></hawksearch-pagination>
            </div>
        </div>
        <hawksearch-content-zone name="Bottom"></hawksearch-content-zone>
        <hawksearch-content-zone name="Bottom2"></hawksearch-content-zone>
    </div>
`;
